<template>
  <div class="rh-uploader">
    <div
      class="dropboxStyles d-flex flex-column align-center justify-center rounded-xl px-4"
      :class="compacto ? 'py-5' : 'py-8'"
      @click="triggerFileInput"
    >
      <input
        ref="inputArquivo"
        class="input-file-upload"
        type="file"
        :multiple="multiple"
        :accept="accept"
        @change="aoSelecionarArquivos"
        style="display: none"
      />
      <v-icon color="primary" :size="compacto ? 40 : 48" class="mb-2"
        >mdi-cloud-upload-outline</v-icon
      >
      <span class="font-weight-bold primary--text text-subtitle-1 mb-1 text-center">
        {{ titulo || "Upload de documentos" }}
      </span>
      <span class="text-caption grey--text text-center">
        {{ subtitulo || "Clique para selecionar arquivos. Somente PDF, até 2MB." }}
      </span>
      <span v-if="categoria" class="text-caption primary--text mt-2 font-weight-medium">
        <v-icon small color="primary" class="mr-1">mdi-folder-outline</v-icon>
        {{ categoriaNome }}
      </span>
    </div>

    <div v-if="itens && itens.length > 0" class="mt-4">
      <div
        v-for="item in itens"
        :key="item.id"
        class="d-flex align-center justify-space-between mb-2 pa-3 rounded-lg border"
        style="background-color: var(--surface-2); border: 1px solid var(--border) !important"
      >
        <div class="d-flex align-center min-width-0">
          <v-icon :color="item.novo ? 'primary' : 'success'" class="mr-2">
            {{ iconeArquivo(item) }}
          </v-icon>
          <div class="min-width-0">
            <span class="text-body-2 text-truncate font-weight-bold d-block">
              {{ item.nome }}
            </span>
            <span v-if="mostrarCategoria && item.categoria" class="text-caption grey--text mr-2">
              {{ obterTituloCategoria(item.categoria) }}
            </span>
            <span v-if="item.novo && item.tamanho" class="text-caption grey--text">
              {{ formatarTamanho(item.tamanho) }}
            </span>
            <v-chip v-if="item.novo" x-small outlined color="primary" class="ml-1">
              Pendente de envio
            </v-chip>
          </div>
        </div>
        <div class="d-flex">
          <v-btn
            v-if="!item.novo && podeBaixar"
            icon
            color="primary"
            class="mx-1"
            @click.stop="emitirBaixar(item)"
            title="Download"
          >
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-btn icon color="error" class="mx-1" @click.stop="emitirRemover(item)" title="Excluir">
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CATEGORIAS_DOCUMENTO } from "../config/rhConfig";

export default {
  name: "RhDocumentosUploader",
  props: {
    titulo: {
      type: String,
      default: "",
    },
    subtitulo: {
      type: String,
      default: "",
    },
    categoria: {
      type: String,
      default: null,
    },
    itens: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    accept: {
      type: String,
      default: ".pdf,application/pdf",
    },
    podeBaixar: {
      type: Boolean,
      default: true,
    },
    compacto: {
      type: Boolean,
      default: false,
    },
    mostrarCategoria: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    categoriaNome() {
      return this.obterTituloCategoria(this.categoria);
    },
  },
  methods: {
    triggerFileInput() {
      if (this.$refs.inputArquivo) {
        this.$refs.inputArquivo.click();
      }
    },
    aoSelecionarArquivos(event) {
      const files = Array.from(event.target.files || []);
      if (files.length === 0) {
        return;
      }
      this.$emit("adicionar", {
        files,
        categoria: this.categoria,
      });
      if (this.$refs.inputArquivo) {
        this.$refs.inputArquivo.value = "";
      }
    },
    emitirRemover(item) {
      this.$emit("remover", item);
    },
    emitirBaixar(item) {
      this.$emit("baixar", item);
    },
    iconeArquivo(item) {
      const nome = (item.nome || "").toLowerCase();
      if (nome.endsWith(".pdf")) {
        return "mdi-file-pdf-box";
      }
      if (/\.(jpe?g|png|gif|bmp|webp)$/i.test(nome)) {
        return "mdi-file-image-outline";
      }
      return "mdi-file-document-outline";
    },
    obterTituloCategoria(id) {
      if (!id) {
        return "Outros documentos";
      }
      const categoria = CATEGORIAS_DOCUMENTO.find((item) => item.id === id);
      return categoria ? categoria.titulo : "Outros documentos";
    },
    formatarTamanho(bytes) {
      if (!bytes && bytes !== 0) {
        return "";
      }
      if (bytes < 1024) {
        return `${bytes} B`;
      }
      const kb = bytes / 1024;
      if (kb < 1024) {
        return `${Math.round(kb)} KB`;
      }
      const mb = kb / 1024;
      return `${mb.toFixed(1)} MB`;
    },
  },
};
</script>

<style scoped>
.dropboxStyles {
  outline: 2px dashed var(--brand);
  background-color: var(--brand-soft);
  color: var(--text-muted);
  cursor: pointer;
  transition: background-color 160ms ease, box-shadow 160ms ease;
}

.dropboxStyles:hover {
  background-color: var(--brand-soft-2);
  box-shadow: 0 6px 22px var(--shadow);
}
</style>
